export function filterRelevance(properties, min, max) {
    return properties.reduce((props, prop) => {
        if (prop.properties.relevance >= min && prop.properties.relevance <= max) {
            return [...props, prop.name];
        }
        return [...props];
    }, []);
}
export function formatAdMetadata(metaData, limits) {
    const cutMetadata = {};
    if (metaData.iabTier1) {
        const filtered = filterRelevance(metaData.iabTier1, limits.iabTier1.min, limits.iabTier1.max);
        if (filtered.length > 0) {
            cutMetadata.iabTier1 = filtered;
        }
    }
    if (metaData.iabTier2) {
        const filtered = filterRelevance(metaData.iabTier2, limits.iabTier2.min, limits.iabTier2.max);
        if (filtered.length > 0) {
            cutMetadata.iabTier2 = filtered;
        }
    }
    if (metaData.leikiHighDef) {
        const filtered = filterRelevance(metaData.leikiHighDef, limits.semantics.min, limits.semantics.max);
        if (filtered.length > 0) {
            cutMetadata.semantics = filtered;
        }
        cutMetadata.rawSemantics = filterRelevance(metaData.leikiHighDef, 0, 100);
    }
    return cutMetadata;
}
//# sourceMappingURL=format.js.map